import { CommonModule, NgIf } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { Component, OnInit, OnDestroy, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ProductContextService } from '../core/product-context.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-language-changer',
  templateUrl: './language-changer.component.html',
  styleUrls: ['./language-changer.component.scss'],
  standalone: true,
  imports: [MatChipsModule, NgIf, CommonModule, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LanguageChangerComponent implements OnInit, OnDestroy {
  availableLanguages: string[] = [];
  salesOrganization: string = '';
  language: string = '';
  serialNumber: string = '';

  private subscriptions: Subscription = new Subscription();

  constructor(
    private productContextService: ProductContextService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    // Read salesOrganization, language, serialNumber directly from the current URL
    this.subscriptions.add(
      this.router.events.pipe(
        filter(e => e instanceof NavigationEnd),
        startWith(null)
      ).subscribe(() => {
        const leaf = this.getLeafRoute();
        this.salesOrganization = leaf.snapshot.params['salesOrganization'] ?? '';
        this.language = leaf.snapshot.params['language'] ?? '';
        this.serialNumber = leaf.snapshot.params['id'] ?? '';
      })
    );

    this.subscriptions.add(
      this.productContextService.availableLanguages$.subscribe(languages => {
        this.availableLanguages = languages;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private getLeafRoute(): ActivatedRoute {
    let route = this.route;
    while (route.firstChild) route = route.firstChild;
    return route;
  }
}

